export default "__VITE_ASSET__Dt$PruzF__"